export class UpdateFkEditorUseCase{
  constructor(repository) {
    this.repository = repository
  }
  async execute(ID_SECTOR,FK_EDITOR){
    const resp = await this.repository.updateFkEditor(ID_SECTOR,FK_EDITOR)
    if(resp && resp[0].length){
      console.log('Usuário atrelado ao setor')
    }

    return
  }
}
